import { createSlice } from '@reduxjs/toolkit';

import { IReviewsData } from 'shared/types/reviews';

const initialState: IReviewsData = {
  reviews: [],
  totalCount: 0,
};

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  selectors: {
    selectReviews: state => state,
  },
});

export const {
  reducer: reviewsReducer,
  // eslint-disable-next-line no-empty-pattern
  actions: {},
  selectors: { selectReviews },
} = reviewsSlice;
